import { SPHPhone } from './../../shared/model/sph-phone.model';
import { LicenseManagerService, SPHLoggedInUser, SPHLicense, SPHApplication } from './../../shared/shared';
import { ViewController, ToastController, NavParams } from 'ionic-angular';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lm-push',
  templateUrl: 'push.component.html'
})

export class PushComponent {
  private canSend = false;

  private _license: SPHLicense;
  @Input() set license(license: SPHLicense) {
    this._license = license;
  }

  get license(): SPHLicense {
    return this._license;
  }

  private _user: SPHLoggedInUser;
  @Input() set user(user: SPHLoggedInUser) {
    this._user = user;
  }

  get user(): SPHLoggedInUser {
    return this._user;
  }

  private message: string = '';
  private topic: string = '';
  private pushmessages: SPHApplication[] = [];
  private applications: SPHApplication[] = null;

  private MAX_TOPIC_LENGTH = 50;
  private MAX_LENGTH = 250;

  constructor(private navParams: NavParams, private viewController: ViewController, private licenseManager: LicenseManagerService, private toastController: ToastController) {
    this.user = navParams.get('user');
    this.license = navParams.get('license');
    const phones: [SPHPhone] = navParams.get('phones');
    this.applications = [];
    phones.forEach( (phone) => { this.applications.push(phone.application); } );
  }

  public didTapAbort() {
    this.viewController.dismiss();
  }

  public textAreaDidChange(event) {
    this.canSend = this.message.length > 0 && this.message.length <= this.MAX_LENGTH && this.pushmessages.length > 0;
  }

  public topicTextAreaDidChange(event) {
    this.canSend = this.topic.length <= this.MAX_TOPIC_LENGTH && this.pushmessages.length > 0;
  }

  public sendPush() {

    this.pushmessages.forEach( (push) => {
      this.licenseManager.sendPush(this.topic, this.message, this.license.id, push.id, this.user.jwt).subscribe((response) => {
        const toast = this.toastController.create({message: 'Nachricht gesendet', duration: 3000});
        toast.present();
        this.viewController.dismiss();
      }, this.licenseManager.handleHttpError('Fehler beim senden der Push-Nachricht.'));
    } );
  }

  private shouldSendPush(application: SPHApplication) {
    return this.pushmessages.filter((element) => element.id === application.id).length > 0;
  }

  private didTapActivatePush(application: SPHApplication) {
    if (this.shouldSendPush(application)) {
      this.pushmessages = this.pushmessages.filter((element) => element.id !== application.id);
    } else {
      this.pushmessages.push(application);
    }
    this.textAreaDidChange(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/pushComponent/push.component.ts